// @flow

import React from 'react';
import { formatPhoneNumber } from 'client/utils/format';
import InputGroup, { inputGroupDefaultProps, type InputGroupProps } from './inputGroup';

export type InputPhoneProps = {
  ...$Exact<InputGroupProps>,
  value: string, // overwrites default in InputGroupProps
  changeHandler: Function,
};

const defaultProps = {
  ...inputGroupDefaultProps,
  changeHandler: () => {},
};

const InputPhone = ({ changeHandler, children, ...props }: InputPhoneProps) => (
  <InputGroup
    {...props}
    type="tel"
    onChange={(ev) => {
      const newVal = formatPhoneNumber(ev.target.value, props.value);
      changeHandler(newVal);
    }}>
    {children}
  </InputGroup>
);

InputPhone.defaultProps = defaultProps;

export default InputPhone;
